import React from "react";
import "./Workers.css";

function Card({ src, name, job, exp }) {
  return (
    <div className="wcard">
      <img src={src} alt="cardimg" />
      {/* <div className="card_items"> */}
        <h1 className="anim">{name}</h1>
        <h2 className="anim">{job}</h2>
        <p className="anim">Experience: {exp}</p>
      {/* </div> */}
    </div>
  );
}

export default Card;
